module.exports = __webpack_public_path__ + "static/media/video.a3e20955.mp4";